import { CreateOrEditPriceListFormValues, PriceListCreate } from "./priceListTypes"
import { flatMap, groupBy, map } from "lodash"
import { Customer, CustomerFlat } from "./priceListTypes"

export function mapDataToCreateOrEdit(data: CreateOrEditPriceListFormValues, merchantId: number): PriceListCreate {
    return {
        merchant: { id: merchantId },
        customers: data.customers ?? [],
        internalNote: data.internalNote,
        isActive: data.isActive,
        messageToCustomers: data?.messageToCustomers,
        name: data.name,
        priceSetup: {
            currencyCode: data.currencyCode,
            priceAdjustment: {
                percentage: { amount: +data.percentage * Math.pow(10, 2), scale: 2 },
                type: data.priceAdjustmentType,
            },
            vatCodeId: data?.vatCodeId ? +data.vatCodeId : undefined,
        },
        isDefaultPOSPriceList: data.isDefaultPOSPriceList,
        cardSubscriptions: data.cardSubscriptions.map((cardType) => ({ id: cardType.id })),
        shops: data.shops.map((id) => ({ id })),
    }
}

export function convertCustomersByUserGroup(customers: Customer[]): CustomerFlat[] {
    return flatMap(
        customers,
        (customer) =>
            customer?.userGroups.map((group) => ({
                customerId: customer.id,
                customerName: customer.name,
                userGroupId: group.id,
                userGroupName: group.name,
            })),
    )
}

export function convertFlatToCustomers(flatData: CustomerFlat[]): Customer[] {
    const grouped = groupBy(flatData, "customerId")
    return map(grouped, (entries, customerId) => ({
        id: parseInt(customerId),
        name: entries[0].customerName,
        userGroups: entries.map((entry) => ({
            id: entry.userGroupId,
            name: entry.userGroupName,
        })),
    }))
}
